const JWT_TOKEN = 'token';

export const jwt = {
  get: () => window.localStorage.getItem(JWT_TOKEN),

  set: (token = null) => {
    window.localStorage.setItem(JWT_TOKEN, token);
  },
};
